/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ISO639_1 } from './ISO639_1'
import { CodeStub } from './CodeStub'

/**
 * Text node with attribution. Could be written by a healthcare party, as a side node of a     |medical record. For example, after taking a temperature, the HCP adds a node explaining the     |thermometer is faulty.
 */
export class Annotation {
  constructor(json: JSON | any) {
    Object.assign(this as Annotation, json)
  }

  /**
   * The Id of the Annotation. We encourage using either a v4 UUID or a HL7 Id.
   */
  id?: string
  author?: string
  /**
   * The timestamp (unix epoch in ms) of creation of this note, will be filled automatically if missing. Not enforced by the application server.
   */
  created?: number
  /**
   * The timestamp (unix epoch in ms) of the latest modification of this note, will be filled automatically if missing. Not enforced by the application server.
   */
  modified?: number
  /**
   * Text contained in the note, written as markdown.
   * @deprecated use markdown instead
   */
  text?: string

  /**
   * Text contained in the note, written as markdown.
   */
  markdown?: { [lang in ISO639_1]?: string }

  /**
   * A tag is an item from a codification system that qualifies an entity as being member of a certain class, whatever the value it might have taken. If the tag qualifies the content of a field, it means that whatever the content of the field, the tag will always apply. For example, the label of a field is qualified using a tag. LOINC is a codification system typically used for tags.
   */
  tags?: Array<CodeStub>

  /**
   * Defines to which part of the corresponding information the note is related to.
   */
  location?: string

  encryptedSelf?: string
}
